import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import Layout from "./components/Layout";
import GoogleAnalytics from "./components/GoogleAnalytics";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DomainsPage from "./pages/DomainsPage";
import DomainDetailPage from "./pages/DomainDetailPage";
import AuctionsPage from "./pages/AuctionsPage";
import DashboardPage from "./pages/DashboardPage";
import AdminPage from "./pages/AdminPage";
import ContactPage from "./pages/ContactPage";
import ValuationPage from "./pages/ValuationPage";
import DomainGardenPage from "./pages/DomainGardenPage";
import SellDomainPage from "./pages/SellDomainPage";
import BrokeragePage from "./pages/BrokeragePage";
import RentDomainPage from "./pages/RentDomainPage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import DomainDonationPage from "./pages/DomainDonationPage";
import AffiliatePage from "./pages/AffiliatePage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import DomainFinancingPage from "./pages/DomainFinancingPage";
import AdvancedSearchPage from "./pages/AdvancedSearchPage";
import AdminAnalyticsPage from "./pages/AdminAnalyticsPage";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import SecuritySettingsPage from "./pages/SecuritySettingsPage";
import AdminAuctionControlPage from "./pages/AdminAuctionControlPage";
import AdminFinancialPage from "./pages/AdminFinancialPage";
import AdminGardenPage from "./pages/AdminGardenPage";
import AdminBrokeragePage from "./pages/AdminBrokeragePage";
import AdminBulkImportPage from "./pages/AdminBulkImportPage";
import AdminDonationsPage from "./pages/AdminDonationsPage";
import MarketplaceAnalyticsPage from "./pages/MarketplaceAnalyticsPage";
import BugReportPage from "./pages/BugReportPage";
import AdminBugReportsPage from "./pages/AdminBugReportsPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LanguageProvider>
          <GoogleAnalytics />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/domains" element={<DomainsPage />} />
              <Route path="/domains/:id" element={<DomainDetailPage />} />
              <Route path="/auctions" element={<AuctionsPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
              <Route path="/admin/settings" element={<AdminSettingsPage />} />
              <Route path="/admin/auctions" element={<AdminAuctionControlPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/valuation" element={<ValuationPage />} />
              <Route path="/domain-garden" element={<DomainGardenPage />} />
              <Route path="/sell-domain" element={<SellDomainPage />} />
              <Route path="/brokerage" element={<BrokeragePage />} />
              <Route path="/rent-domain" element={<RentDomainPage />} />
              <Route path="/auth/callback" element={<AuthCallbackPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:id" element={<BlogPostPage />} />
              <Route path="/domain-donation" element={<DomainDonationPage />} />
              <Route path="/affiliate" element={<AffiliatePage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/financing" element={<DomainFinancingPage />} />
              <Route path="/financing/:domainId" element={<DomainFinancingPage />} />
              <Route path="/search" element={<AdvancedSearchPage />} />
              <Route path="/security" element={<SecuritySettingsPage />} />
              <Route path="/admin/financial" element={<AdminFinancialPage />} />
              <Route path="/admin/garden" element={<AdminGardenPage />} />
              <Route path="/admin/brokerage" element={<AdminBrokeragePage />} />
              <Route path="/admin/bulk-import" element={<AdminBulkImportPage />} />
              <Route path="/admin/donations" element={<AdminDonationsPage />} />
              <Route path="/admin/bug-reports" element={<AdminBugReportsPage />} />
              <Route path="/marketplace-analytics" element={<MarketplaceAnalyticsPage />} />
              <Route path="/bug-report" element={<BugReportPage />} />
            </Routes>
          </Layout>
          <Toaster position="bottom-right" theme="dark" />
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
